import styled from 'styled-components';
import { Progress, DatePicker, Button } from "antd";
import {
  DisplayFlex
} from "../../../../../../CommonComponents/commonStyles";

export const PercentageLabel = styled.div`
  line-height: '9px', 
  margin-left: '6px'
`;

export const DetailLabel = styled.div`
  border-top: 0.5px solid #9b9b9b;
  padding-top: 15px;
  padding-bottom: 15px;
`

export const ExpandableDiv = styled.div`
  overflow-y: auto;

  .textWrapper {
    width: 150px;
    padding-bottom: 10px;
  }

`;

export const IODDatepicker = styled(DatePicker)`
  &&&{
    width: 47% !important;
  }
`;

export const IODSearchButton = styled(Button)`
  height: 30px;
  width: 30%;
  font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
  background-color: ${props => props.theme.colors.white};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.border};
  font-stretch: ${props => props.theme.fontStretch.normal};
  border-radius: 18px;
  font-style: normal;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  display: flex;
  justify-content: center;
  margin: 10px 0px 10px 0;
  &.search{
    line-height: 1.7rem;
    width: 100px;    
  }
  &:hover, :focus {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.primaryColor};
    border 1px solid ${props => props.theme.colors.border};
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const MobilePoolDesc = styled.div`
  padding 10px 0px
`;


export const DisplayFlexDP = styled.div`
  display:flex;
  justify-content: space-between;
  width:100%;
  .ant-calendar-picker:hover .ant-calendar-picker-clear {
    display: none;
  }
`;

export const ProgressUpdated = styled(Progress)`
  &&&{
    .ant-progress-circle-trail{
      stroke: #f0ab00 !important;
    }
  }
`;


export const DisplayFlexUpdated = styled(DisplayFlex)`
  margin-bottom:16px;
`;